(function () {
  const GRID_SELECTOR = '#main-collection-product-grid';
  const ITEM_SELECTOR = '.product-item.card[data-shop-order]';

  function sortGrid() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(ITEM_SELECTOR));
    if (!items.length) return;

    items.sort((a, b) => {
      const aOrder = parseInt(a.dataset.shopOrder, 10) || 999;
      const bOrder = parseInt(b.dataset.shopOrder, 10) || 999;
      return aOrder - bOrder;
    });

    items.forEach(item => grid.appendChild(item));
  }

  function observeGrid() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    // Initial sort
    sortGrid();

    // Re-sort when filters / AJAX update products
    const observer = new MutationObserver(() => {
      sortGrid();
    });

    observer.observe(grid, {
      childList: true
    });
  }

  // Wait until everything (including filters JS) is loaded
  window.addEventListener('load', observeGrid);
})();
